module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ack",
      "epub:type": "acknowledgments",
      "role": "doc-acknowledgments"
    }
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head--fmh-"
  }, [_c('span', {
    attrs: {
      "aria-label": "5",
      "id": "pg_5",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-No-Indent--fmtx1-"
  }, [_vm._v("The usual suspects: my wife, Mary; Jennifer Gunnels and Becky Maines at the publisher; Steven Spruill, Elizabeth Monteleone, Dannielle Romeo, Ann Voss Peterson, Alfred Caplin, and my agent, Albert Zuckerman. Thanks for your efforts.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b285ee4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0